export const RELAY_PENDING_TIMEOUT_MS = 15000;
export const RELAY_SOCKET_MAP = {
  ac: 1,
  dryer: 2,
  co2: 3,
  extra: 4,
};
export const RELAY_MODE_AUTO = 'auto';
export const RELAY_MODE_MANUAL_ON = 'manual_on';
export const RELAY_MODE_MANUAL_OFF = 'manual_off';
export const CONTROL_STATE_AUTO = 'auto';
export const CONTROL_STATE_TEMPORARY_MANUAL_OVERRIDE = 'temporary_manual_override';
export const CONTROL_STATE_MANUAL_LOCK = 'manual_lock';

export function normalizeRelayMode(mode) {
  const token = String(mode || '').trim().toLowerCase();
  if (token === RELAY_MODE_MANUAL_ON || token === RELAY_MODE_MANUAL_OFF || token === RELAY_MODE_AUTO) {
    return token;
  }
  return RELAY_MODE_AUTO;
}

export function relayModeToControlState(mode) {
  const normalized = normalizeRelayMode(mode);
  if (normalized === RELAY_MODE_AUTO) return CONTROL_STATE_AUTO;
  return CONTROL_STATE_MANUAL_LOCK;
}

export function normalizeRelayMap(source = {}) {
  const relays = source?.relays || source?.meta?.relays || {};
  const socketStates = source?.socketStates || source?.sockets || source?.meta?.sockets || {};
  const deviceStatuses = source?.deviceStatuses || source?.meta?.device_statuses || {};
  const controlOutlets = Array.isArray(source?.control?.outlets) ? source.control.outlets : [];
  const controlOutletState = Object.fromEntries(controlOutlets.map((outlet) => [outlet?.key, outlet?.state]));
  const toRelayBit = (value) => {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value === 'boolean') return value ? 1 : 0;
    const token = String(value).trim().toLowerCase();
    if (token === 'on' || token === 'active' || token === 'true') return 1;
    if (token === 'off' || token === 'inactive' || token === 'false') return 0;
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return null;
    return numeric === 1 ? 1 : 0;
  };
  const acRelay = toRelayBit(
    controlOutletState.ac ??
      socketStates.temperature ??
      deviceStatuses.ac ??
      relays.ac ??
      relays.rA ??
      source?.rA
  );
  const dryerRelay = toRelayBit(
    controlOutletState.dryer ??
      socketStates.humidity ??
      deviceStatuses.dehumidifier ??
      relays.dryer ??
      relays.dehumidifier ??
      relays.rD ??
      source?.rD
  );
  const co2Relay = toRelayBit(
    controlOutletState.co2 ??
      socketStates.co2 ??
      deviceStatuses.co2 ??
      relays.co2 ??
      relays.rC ??
      source?.rC
  );
  const extraRelay = toRelayBit(
    controlOutletState.extra ??
      socketStates.reserve ??
      deviceStatuses.reserve ??
      relays.extra ??
      relays.reserve ??
      relays.rL ??
      source?.rL
  );
  return {
    ac: acRelay,
    dryer: dryerRelay,
    co2: co2Relay,
    extra: extraRelay,
  };
}
